import { useContext } from 'react';
import { LangContext } from '@/context/LangProvider';

const useTranslation = () => useContext(LangContext);

export default useTranslation;
